import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      actionsToRunOnRefresh: [this.requestSidebarContent],
      isSidebarContentRefreshInProgress: false
    }
  },
  computed: {
    ...mapGetters({
      mustReadItems: 'sidebar/mustReadItems'
    }),
    $_sidebarRefresh_mustReadItemsForRefreshListener() {
      return this.mustReadItems.map(article => ({
        articleId: article.id,
        category: {
          slug: article.categorySlug
        }
      }))
    }
  },
  watch: {
    '$route.path': {
      handler() {
        if (process.client) {
          this.$_sidebarRefresh_refreshSidebarContent()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      requestSidebarContent: 'sidebar/requestSidebarContent'
    }),
    /**
     * MustRead items works through the state and getters.
     * That's why we don't need ARefreshListener to update our items.
     * Instead, we listen to the event feed-update-required to initiate the
     * request. Getter values will be updated and re-rendered automatically.
     */
    async $_sidebarRefresh_refreshSidebarContent() {
      try {
        this.isSidebarContentRefreshInProgress = true
        await Promise.all(this.actionsToRunOnRefresh.map(action => action()))
      } catch (err) {
        throw err
      } finally {
        this.isSidebarContentRefreshInProgress = false
      }
    }
  },
  mounted() {
    this.$_sidebarRefresh_refreshSidebarContent()
  }
}
